<template>
  <table class="ag-grafico-barra">
    <tbody>
      <tr
        v-for="(item, index) in items"
        :key="index"
        class="ag-grafico-barra__line"
      >
        <td
          class="ag-grafico-barra__spacings ag-grafico-barra__prepend"
          :style="{ color: item.textColor }"
          :title="item.prependTooltip || item.prependLabel"
        >
          {{ item.prependLabel }}
        </td>
        <td
          class="ag-grafico-barra__spacings"
          :class="{ 'ag-grafico-barra__separador': index < items.length - 1 }"
        >
          <v-progress-linear
            height="16"
            bg-opacity="0"
            rounded
            :buffer-opacity="1"
            :model-value="item.value"
            :color="item.color"
            :max="maxValue"
          />
        </td>
        <td
          v-if="item.appendLabel"
          class="ag-grafico-barra__spacings ag-grafico-barra__append"
          :class="{ 'ag-grafico-barra__separador': index < items.length - 1 }"
          :style="{ color: item.color }"
        >
          {{ item.appendLabel }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { sumBy } from 'lodash'

export default {
  props: {
    /** @type {ModelGraficoBarraItem[]} */
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    maxValue() {
      return sumBy(this.items, 'value') === 0 ? 1 : sumBy(this.items, 'value')
    }
  }
}
</script>

<style scoped lang="scss">
.ag-grafico-barra {
  border-collapse: collapse;
  flex: 1;
  font-size: $font-size-xxs;

  .ag-grafico-barra__line {
    .ag-grafico-barra__prepend {
      color: $neutral-color-high-medium;
      padding-right: 16px !important;
      text-align: right;
      width: 1%;
      white-space: nowrap;
    }

    .ag-grafico-barra__spacings {
      padding: $spacing-03 0;
    }

    .ag-grafico-barra__append {
      padding-left: 16px !important;
      text-align: right;
      width: 1%;
      white-space: nowrap;
    }
  }

  .ag-grafico-barra__separador {
    border-bottom: 1px solid $neutral-color-low-dark;
  }
}

::v-deep(.v-progress-linear__determinate) {
  border-radius: inherit;
  min-width: 16px;
}
</style>
